export type NetworkOperationResult = {
	status: "OK" | "CONFIRMED" | "SUCCESS" | "ERROR",
	message: string,
	data?: any
}